import { connect } from 'react-redux'
import SubProjects from './SubProjects'

import componentDidMount from './Handlers/componentDidMount'

const mapStateToProps = (state) => ({
})

const actionCreators = {
  componentDidMount,
}

export default connect(mapStateToProps, actionCreators)(SubProjects)
